import { HTMLAttributes, ReactNode } from 'react'


export enum List_TYPE {
   ORDERD,
   ORDERD_WITH_ICONS,
   UNORDERED,
}

export type AppListProps = HTMLAttributes<HTMLOListElement> & {
   /** Dzieci – List itemy*/
   children: ReactNode;
   /** Dodatkowa klasa pozwalająca dodać customowe właściwości */
   className?: string
   listType?: List_TYPE;
}

